// extracted by mini-css-extract-plugin
export var cardContainer = "_q3-0";
export var cardHeader = "_q3-2";
export var collapsedState = "_q3-3";
export var dragHandle = "_q3-5";
export var dragHandleIcon = "_q3-6";
export var dragging = "_q3-1";
export var titleArea = "_q3-4";